import { lazy } from 'react';

export const Dashboards = [
  {
    path: '/dashboard/onboarding',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/OnboardingDashboard')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/Compliance/:id',
    component: lazy(() => import('@src/views/dashboard/Onboarding/Compliance')),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/company/wizard',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/CompanyIntegration')
    ),
    exact: true,
    meta: {
      action: 'create_company_onboarding_wizard',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/ComplianceCaf/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/ComplianceCaf')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/partnersPage/:doc/:docType',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/Compliance/partnersPage')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/onboarding/company/register',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/CompanyIntegration')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/createOperator',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/CreateOperatorOnboarding')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/invitesOperators',
    component: lazy(() =>
      import('@src/views/dashboard/Onboarding/ListInvitesByOperator')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/create/company/wizard',
    component: lazy(() => import('../../views/pages/RegistrationWizard')),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/editInviteByOperator/:email',
    component: lazy(() =>
      import(
        '@src/views/dashboard/Onboarding/ListInvitesByOperator/EditInviteByOperator'
      )
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/analytics',
    component: lazy(() => import('@src/views/dashboard/Analytics')),
    exact: true,
    meta: {
      action: 'view_analytics',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/analytics/companies',
    component: lazy(() => import('@src/views/dashboard/AnalyticsCompanies')),
    exact: true,
    meta: {
      action: 'view_analytics_whitelabel',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/analytics/preview/whitelabel/:idcompany',
    component: lazy(() =>
      import('@src/views/dashboard/AnalyticsCompaniesWhiteLabel')
    ),
    exact: true,
    meta: {
      action: 'view_analytics_whitelabel',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/analytics/preview/:idcompany',
    component: lazy(() => import('@src/views/dashboard/AnalyticsWhiteLabel')),
    exact: true,
    meta: {
      action: 'view_analytics',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/reports',
    component: lazy(() => import('@src/views/dashboard/Reports/ViewReports')),
    exact: true,
    meta: {
      action: 'view_analytics',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/exchange/conciliation/create',
    component: lazy(() =>
      import(
        '@src/views/dashboard/ConciliateExchangeTransactions/CreateConciliateExchangeTransactions'
      )
    ),
    exact: true,
    meta: {
      action: 'view_conciliate_exchange_transactions',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/reports/preview/:idcompany/:initialDate/:finalDate',
    component: lazy(() => import('@src/views/dashboard/Reports/ReportPreview')),
    exact: true,
    meta: {
      action: 'view_analytics',
    },
  },
  {
    path: '/dashboard/ecommerce',
    component: lazy(() => import('@src/views/dashboard/Ecommerce')),
    exact: true,
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/customers',
    component: lazy(() =>
      import('@src/views/dashboard/Customers/ViewCustomers')
    ),
    exact: true,
    meta: {
      action: 'view_customers',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/customers/create',
    component: lazy(() =>
      import('@src/views/dashboard/Customers/CreateCustomer')
    ),
    exact: true,
    meta: {
      action: 'create_customers',
    },
  },
  {
    path: '/dashboard/establishments/:id/terminals',
    component: lazy(() =>
      import('@src/views/dashboard/Terminals/ViewTerminals')
    ),
    exact: true,
    meta: {
      action: 'view_establishments_terminals',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/terminals/create',
    component: lazy(() =>
      import('@src/views/dashboard/Terminals/CreateTerminal')
    ),
    exact: true,
    meta: {
      action: 'create_establishments_terminals',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/terminals/edit/:companyTerminalId',
    component: lazy(() =>
      import('@src/views/dashboard/Terminals/EditTerminal')
    ),
    exact: true,
    meta: {
      action: 'create_establishments_terminals',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/transactions',
    component: lazy(() => import('@src/views/dashboard/Payments')),
    exact: true,
    meta: {
      action: 'view_transactions',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/BankingActivity',
    component: lazy(() => import('@src/views/dashboard/BankingActivity')),
    exact: true,
    meta: {
      action: 'view_bank_statement',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/transactions/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Payments/PaymentPreview')
    ),
    exact: true,
    meta: {
      action: 'view_transaction',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/anticipations',
    component: lazy(() =>
      import('@src/views/dashboard/Anticipations/ViewAnticipations')
    ),
    exact: true,
    meta: {
      action: 'view_anticipations',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/distributors',
    component: lazy(() =>
      import('@src/views/dashboard/Distributors/ViewDistributors')
    ),
    exact: true,
  },
  {
    path: '/dashboard/distributors/create',
    component: lazy(() =>
      import('@src/views/dashboard/Distributors/CreateDistributor')
    ),
    exact: true,
  },
  {
    path: '/dashboard/distributors/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Distributors/EditDistributor')
    ),
    exact: true,
  },
  {
    path: '/dashboard/promoters',
    component: lazy(() =>
      import('@src/views/dashboard/Promoters/ViewPromoters')
    ),
    exact: true,
  },
  {
    path: '/dashboard/promoters/create',
    component: lazy(() =>
      import('@src/views/dashboard/Promoters/CreatePromoter')
    ),
    exact: true,
  },
  {
    path: '/dashboard/establishments/editallfee',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/EditEstablishmentFee')
    ),
    exact: true,
    meta: {
      action: 'view_establishments',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/ViewEstablishments')
    ),
    exact: true,
    meta: {
      action: 'view_establishments',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/create',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/CreateEstablishmentV2')
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:idcompany',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/ListEstablishments')
    ),
    exact: true,
    meta: {
      action: 'view_establishments',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/EstablishmentPreview')
    ),
    exact: true,
    meta: {
      action: 'view_establishment',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/rates',
    component: lazy(() =>
      import('@src/views/dashboard/Rates/ListCompanyRates')
    ),
    exact: true,
    meta: {
      action: 'view_establishment_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/rates/brand',
    component: lazy(() => import('@src/views/dashboard/Rates/BrandList')),
    exact: true,
    meta: {
      action: 'view_establishment_brands',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/edit/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/EditEstablishment')
    ),
    exact: true,
    meta: {
      action: 'edit_establishments',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/operators',
    component: lazy(() =>
      import('@src/views/dashboard/Operators/ViewOperators')
    ),
    exact: true,
    meta: {
      action: 'view_operators',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/operators/create',
    component: lazy(() =>
      import('@src/views/dashboard/Operators/CreateOperator')
    ),
    exact: true,
    meta: {
      action: 'create_operators',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/acquirers',
    component: lazy(() =>
      import('@src/views/dashboard/SettingsMethodsPayments/ViewMethodsPayments')
    ),
    exact: true,
    meta: {
      action: 'view_establishment_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/credentials',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/ViewCredentials')
    ),
    exact: true,
    meta: {
      action: 'view_credentials',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/splits/create',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/CreatePixSplitSettings')
    ),
    exact: true,
    meta: {
      action: 'view_establishment_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/establishments/:id/splits/edit',
    component: lazy(() =>
      import('@src/views/dashboard/Establishments/EditPixSplitSettings')
    ),
    exact: true,
    meta: {
      action: 'view_pix_with_split',
      resource: 'ACL',
    },
  },
  {
    path: '/rates/standard',
    component: lazy(() =>
      import('@src/views/dashboard/Rates/ViewStandardRate')
    ),
    exact: true,
    meta: {
      action: 'view_standard_rates',
    },
  },
  {
    path: '/rates/standard/create',
    component: lazy(() =>
      import('@src/views/dashboard/Rates/CreateStandardRates')
    ),
    exact: true,
    meta: {
      action: 'create_standard_rates',
    },
  },
  {
    path: '/rates/standard/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Rates/ViewStandardRate')
    ),
    exact: true,
    meta: {
      action: 'view_standard_rate',
    },
  },
  {
    path: '/dashboard/myaccount',
    component: lazy(() => import('@src/views/dashboard/MyAccount')),
    exact: true,
    meta: {
      action: 'view_my_account',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/myaccount/edit',
    component: lazy(() => import('@src/views/dashboard/MyAccountEdit')),
    exact: true,
    meta: {
      action: 'edit_my_account',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/payment/links',
    component: lazy(() =>
      import('@src/views/dashboard/PaymentLinks/ViewPaymentLinks')
    ),
    exact: true,
    meta: {
      action: 'view_links',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/payment/links/create',
    component: lazy(() =>
      import('@src/views/dashboard/PaymentLinks/CreatePaymentLink')
    ),
    exact: true,
    meta: {
      action: 'create_links',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/payment/links/fixed',
    component: lazy(() =>
      import('@src/views/dashboard/PaymentLinksFixed/ViewPaymentLinksFixed')
    ),
    exact: true,
    meta: {
      action: 'view_links',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/payment/links/create/fixed',
    component: lazy(() =>
      import('@src/views/dashboard/PaymentLinksFixed/CreatePaymentLinkFixed')
    ),
    exact: true,
    meta: {
      action: 'create_links',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/payment/links/fixed/:idrecurrence',
    component: lazy(() =>
      import(
        '@src/views/dashboard/PaymentLinksFixed/ViewPaymentDetailsLinksFixed'
      )
    ),
    exact: true,
    meta: {
      action: 'view_links',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/fixed/recurrences',
    component: lazy(() =>
      import('@src/views/dashboard/FixedRecurrences/ViewFixedRecurrences')
    ),
    exact: true,
    meta: {
      action: 'view_recurrences',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/fixed/recurrences/create',
    component: lazy(() =>
      import('@src/views/dashboard/FixedRecurrences/CreateFixedRecurrence')
    ),
    exact: true,
    meta: {
      action: 'view_recurrences',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/fixed/recurrences/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/FixedRecurrences/FixedRecurrencesPreview')
    ),
    exact: true,
    meta: {
      action: 'view_recurrence',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/recurrences',
    component: lazy(() =>
      import('@src/views/dashboard/Recurrences/ViewRecurrences')
    ),
    exact: true,
    meta: {
      action: 'view_recurrences',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/recurrences/create',
    component: lazy(() =>
      import('@src/views/dashboard/Recurrences/CreateRecurrence')
    ),
    exact: true,
    meta: {
      action: 'create_recurrences',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/recurrences/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Recurrences/RecurrencePreview')
    ),
    exact: true,
    meta: {
      action: 'view_recurrence',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/myrates',
    component: lazy(() => import('@src/views/dashboard/PaymentOptions')),
    exact: true,
    meta: {
      action: 'view_my_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/customers/rates/:id',
    component: lazy(() => import('@src/views/dashboard/Rates/CompanyRates')),
    exact: true,
    meta: {
      action: 'view_customers_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/customers/rates/mdr/:id',
    component: lazy(() => import('@src/views/dashboard/Rates/ViewMdrRate')),
    exact: true,
    meta: {
      action: 'view_customers_mdr_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/customers/rates/cancellation-chargeback-med_pix/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Rates/ViewCancellationAndChargebackRates')
    ),
    exact: true,
    meta: {
      action: 'view_cancellation_and_chargeback_rates',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/transfers',
    component: lazy(() =>
      import('@src/views/dashboard/Transfers/TransferList')
    ),
    exact: true,
    meta: {
      action: 'view_transfers',
    },
  },
  {
    path: '/dashboard/transfers/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Transfers/PreviewTransfer')
    ),
    exact: true,
    meta: {
      action: 'view_transfer',
    },
  },
  {
    path: '/dashboard/transfers/pending/preview/:companyId/:anticipatedDate',
    component: lazy(() =>
      import('@src/views/dashboard/Transfers/PreviewTransferByCompanyId')
    ),
    exact: true,
    meta: {
      action: 'view_transfer',
    },
  },
  {
    path: '/dashboard/transfers/pending',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/PendingLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_pending',
    },
  },
  {
    path: '/dashboard/transfers/adjustment',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/AdjustmentLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_adjustment',
    },
  },
  {
    path: '/dashboard/transfers/oldpending',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/OldPendingLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_old_pending',
    },
  },
  {
    path: '/dashboard/transfers/processing',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/ProcessingLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_processing',
    },
  },
  {
    path: '/dashboard/transfers/unrealized',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/UnrealizedLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_unrealized',
    },
  },
  {
    path: '/dashboard/transfers/extended',
    component: lazy(() =>
      import('@src/views/dashboard/Liquidations/ExtendedLiquidations')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_extended',
    },
  },
  {
    path: '/dashboard/transfers/chargebacks',
    component: lazy(() =>
      import('@src/views/dashboard/Transfers/ViewChargebacks')
    ),
    exact: true,
    meta: {
      action: 'view_transfers_chargebacks',
    },
  },
  {
    path: '/dashboard/statements',
    component: lazy(() =>
      import('@src/views/dashboard/Statements/ViewStatements')
    ),
    exact: true,
    meta: {
      action: 'view_statements',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/statements/preview/:id',
    component: lazy(() =>
      import('@src/views/dashboard/Statements/PreviewStatement')
    ),
    exact: true,
    meta: {
      action: 'view_statement',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/statements/pending/preview/:companyId/:anticipatedDate',
    component: lazy(() =>
      import('@src/views/dashboard/Statements/PreviewStatementByCompanyId')
    ),
    exact: true,
    meta: {
      action: 'view_statement',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/statements/future/preview/:companyId/:paymentDate',
    component: lazy(() =>
      import(
        '@src/views/dashboard/Statements/PreviewFutureStatementByCompanyId'
      )
    ),
    exact: true,
    meta: {
      action: 'view_statement',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/statements/warranty/preview/:companyId/:paymentDate',
    component: lazy(() =>
      import(
        '@src/views/dashboard/Statements/PreviewWarrantyStatementByCompanyId'
      )
    ),
    exact: true,
    meta: {
      action: 'view_statement',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/simulator',
    component: lazy(() => import('@src/views/dashboard/DebtSimulator')),
    exact: true,
    meta: {
      action: 'view_simulator',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/operators',
    component: lazy(() =>
      import('@src/views/dashboard/OperatorsUsers/ViewOperatorsUsers')
    ),
    exact: true,
    meta: {
      action: 'view_operators_users',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/operators/create',
    component: lazy(() =>
      import('@src/views/dashboard/OperatorsUsers/CreateOperatorUser')
    ),
    exact: true,
    meta: {
      action: 'create_operators_users',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/ediadiq',
    component: lazy(() => import('@src/views/dashboard/EdiAdiq')),
    exact: true,
    meta: {
      action: 'view_edi_adiq',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/ediglobal',
    component: lazy(() => import('@src/views/dashboard/EdiGlobal')),
    exact: true,
    meta: {
      action: 'view_edi_global',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/simulator/fee',
    component: lazy(() => import('@src/views/dashboard/FeeSimulator')),
    exact: true,
    meta: {
      action: 'view_fee_simulator',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/conciliations',
    component: lazy(() =>
      import('@src/views/dashboard/Conciliations/ConciliationsList')
    ),
    exact: true,
    meta: {
      action: 'view_conciliations',
    },
  },
  {
    path: '/dashboard/exported-files',
    component: lazy(() =>
      import('@src/views/dashboard/ExportedFiles/ViewExportedFiles')
    ),
    exact: true,
    meta: {
      action: 'view_exported_files',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/list/users',
    component: lazy(() => import('@src/views/dashboard/Users/ListUsers')),
    exact: true,
    meta: {
      action: 'view_users',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/create/users',
    component: lazy(() => import('@src/views/dashboard/Users/CreateUser')),
    exact: true,
    meta: {
      action: 'create_user',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/edit/:id',
    component: lazy(() => import('@src/views/dashboard/Users/EditUser')),
    exact: true,
    meta: {
      action: 'edit_user',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/roles',
    component: lazy(() => import('@src/views/dashboard/Roles')),
    exact: true,
    meta: {
      action: 'view_roles',
    },
  },
  {
    path: '/dashboard/list/permissions',
    component: lazy(() =>
      import('@src/views/dashboard/Permissions/ListPermissions')
    ),
    exact: true,
    meta: {
      action: 'view_permissions',
    },
  },
  {
    path: '/dashboard/system',
    component: lazy(() => import('@src/views/dashboard/System')),
    exact: true,
    meta: {
      action: 'view_system',
    },
  },
  {
    path: '/dashboard/onboarding/pre-registro',
    component: lazy(() => import('@src/views/dashboard/Onboarding/Leads')),
    exact: true,
    meta: {
      action: 'view_dashboard',
      resource: 'ACL',
    },
  },
  {
    path: '/dashboard/onboarding/editInvitePreRegistrationByOperator/:email',
    component: lazy(() =>
      import(
        '@src/views/dashboard/Onboarding/Leads/Components/EditInvitePreRegistrationByOperator'
      )
    ),
    exact: true,
    meta: {
      action: 'create_establishment',
      resource: 'ACL',
    },
  },
];
